import React from "react";
import {useTranslation} from "react-i18next";
// local
import {dateTimeFormat, dateFormat} from "helpers/datetime";
import HistoryInfo from "components/HistoryInfo";
import {historyOfferAmountTableColumns} from "constants/table.consts";
import {IconEdit, IconPhone} from "components/icons";
import {hasPermission} from "helpers/helper";
import {LockValue} from "components/LockValue";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {InitialsBadge} from "components/InitialsBadge";
import {getFullName} from "helpers/helper";

const OfferTopInfo = ({offer, language, sideData, clickEdit}) => {
  const {t} = useTranslation();

  const createdAt = offer?.createdAt;
  const validUntil = offer?.validUntil;
  const offerPrice = offer?.price ? offer.price.toLocaleString(language ?? "sv") : 0;

  const UserAssignee = offer?.UserAssignee;
  const sellerFullName = getFullName(UserAssignee?.firstName, UserAssignee?.lastName);

  return (
    <React.Fragment>
      <div className="offer-card-view_info __wrapper pos-r">
        <div className="offer-card-view_info __item">
          <h6>{t(sideData.labels.submitted)}</h6>
          {dateTimeFormat(createdAt)}
        </div>
        <div className="offer-card-view_info __item">
          <h6>{t(sideData.labels.validUntil)}</h6>
          {dateFormat(validUntil)}
        </div>
        <LockValue
          canPermissions={[sideData.editPermission]}
          needLabel
          needShowModalToSubscribe
          addClassIcon="ml-1"
        >
          <ButtonTransparent
            icon={<IconEdit />}
            name={sideData.labels.editButton}
            noBorder
            addClass="pa-0"
            onClick={() => hasPermission([sideData.editPermission]) && clickEdit()}
          />
        </LockValue>
        {sideData.buttonPrint}
      </div>
      <div className="offer-card-view_info __wrapper mt-8">
        {offer?.organizationName && (
          <div className="offer-card-view_info __item __name">
            <h6>{t("OFFER_FROM")}</h6>
            {offer?.organizationName}
          </div>
        )}
        <div className="offer-card-view_info __item __price">
          <h6>{`${t(sideData.labels.price)}, ${offer?.CurrencyCode}`}</h6>
          <div>
            <span>{offerPrice}</span>
            <span className="currency">{offer?.CurrencyCode}</span>
            <HistoryInfo
              data={offer?.OfferPriceHistoryEvents}
              columns={historyOfferAmountTableColumns}
              showAmount
            />
          </div>
        </div>
      </div>
      {sideData.labels.contact && (
        <div className="offer-card-view_info __item mt-8">
          <h6 className="mb-4">{t(sideData.labels.contact)}</h6>
          {UserAssignee ? (
            <div className="df-row-center">
              <InitialsBadge
                firstName={UserAssignee?.firstName}
                lastName={UserAssignee?.lastName}
                addClass="mr-2"
              />

              <span className="mr-4 fz-14">{sellerFullName}</span>
              <IconPhone height="15" width="15" />
              <span className="ml-2 fz-14">{UserAssignee?.mobilePhone}</span>
            </div>
          ) : (
            <span>{t("SELLER_ASSIGNEE_NOT_FOUND")}</span>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default OfferTopInfo;
